<div class="card" id="contato">
    <img src="assets/images/images/pencil-holder.svg" alt="Porta Lápis">
    <h2>Contato</h2>
    <div class="information">
        <p>Endereço: <span>Rua Dr. Carlos Mateus, nº1454, centro, Parnamirim/RN – <span>59.146-210</span></span></p>
        <p>Telefone: <span>(84)98792-9137</span></p>
        <p>Email: <span>comdicaparnamirim@yahoo.com.br</span></p>
    </div>
</div>
